<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      :overlay-opacity="0.7"
      :retain-focus="false"
      transition="dialog-bottom-transition"
      content-class="solution-container-modal"
  >
    <v-layout fill-height column class="white">
      <v-btn icon plain :ripple="false" @click="close()" class="btn-close">
        <Close/>
      </v-btn>
      <div class="flex-fill">
        <v-btn v-if="guideYn" color="primary" small :ripple="false" elevation="0" class="btn-guide"
               @click="guideFeedbackOpen">가이드 피드백
        </v-btn>
        <iframe
            name="iframeSolution"
            id="iframeSolution"
            :src="iframe.src"
            :style="iframe.style"
            width="100%"
            scrolling="yes"
            frameborder="0"
        />
      </div>
    </v-layout>
    <!-- TODO. 삭제예정-->
    <GuideFeedbackSheet ref="guideFeedbackSheet" :guideFeedbackPop="true" :unitUseNo="unitUseNo" :guideYn="guideYn" />
  </v-dialog>
</template>

<script>
import Close from '@/components/icons/Close'
import GuideFeedbackSheet from '@/components/layout/bottomSheet/GuideFeedbackSheet'
import store from "@/store";

export default {
  components: {
    Close,
    GuideFeedbackSheet
  },
  props: {
    guideYn: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    unitUseNo: null,
    regDt: null,
    guideSheet: false,
    guideFeedbackPop: false,
    freeYn: null,
    fdbNo: null,
    iframe: {
      // src: 'http://localhost:8081/user/fo/SolutionModal?unitUseNo=416',
      src: '',
      style: 'border:none; vertical-align: top; height: calc(100% - var(--system-bar-height)); margin-top: var(--system-bar-height)',
      scrolling: 'yes'
    },
    test:null
  }),
  // watch: {
  //   unitPop() {
  //     this.dialog = this.unitPop
  //     if (this.unitPop && this.guideYn) {
  //       this.guideFeedbackOpen();
  //     }
  //   },
  //   dialog() {
  //     if (this.dialog) {
  //       // console.log("window.location.host :", window.location.host)
  //       this.iframe.src = window.location.protocol + "//" + window.location.host + "/user/fo/SolutionModal?unitUseNo=" + this.unitUseNo + "&regDt=" + this.regDt
  //     } else {
  //       this.iframe.src = ''
  //     }
  //   },
  //   guideYn() {
  //     this.guideSheet = true;
  //   }
  // },
  mounted() {
    window.addEventListener('message', (event) => {
        if (event.data === 'close') {
          this.closeModal();
        }
      });
  },
  methods: {
    closeModal() {
      this.close()
    },
    open (unitUseNo, regDt) {
      this.unitUseNo = unitUseNo
      this.regDt = regDt
      this.setUnitFreeYn(unitUseNo)
      this.init()
      this.dialog = true

      if (this.guideYn) {
        this.guideFeedbackOpen()
      }
    },
    openInSquare (unitUseNo, freeYn, regDt) {
          this.unitUseNo = unitUseNo
          this.regDt = regDt
          this.freeYn = freeYn
          this.init()
          this.dialog = true

          if (this.guideYn) {
            this.guideFeedbackOpen()
          }
    },
    openGuideFeedback (fdbNo) {
      this.fdbNo = fdbNo
      this.dialog = true
      if (this.guideYn) {
        this.guideFeedbackOpen()
      }
    },
    close () {
      this.reset()
      this.dialog = false
      // this.$emit('sheetClose')
    },
    reset () {
      this.unitUseNo = null
      this.regDt = null
      this.iframe = {
        src: '',
        style: 'border:none; vertical-align: top; height: calc(100% - var(--system-bar-height)); margin-top: var(--system-bar-height)',
        scrolling: 'yes'
      }
    },
    init () {
      if (this.unitUseNo) {
        this.iframe.src = window.location.protocol + "//" + window.location.host + "/user/fo/SolutionModal?unitUseNo=" + this.unitUseNo
        if (this.regDt) this.iframe.src += "&regDt=" + this.regDt
        if (this.freeYn) this.iframe.src += "&freeYn=" + this.freeYn
      }
    },
    guideFeedbackOpen() {
      this.getUnitFdb().then(() => {
        this.setUnitFreeYn(this.unitUseNo)
        this.init()

        this.$nextTick(() => {
           this.$refs.guideFeedbackSheet.sheetOpen(true)
         })
      });
    },
    setUnitFreeYn(unitUseNo) {
      //기본유닛이 아니면 유료 유닛
      const isFree = this.$store.state.remote.solutions.some(item => {
            if (item.freeYn === "Y" && item.unitUseNo == unitUseNo) return true
      })
      this.freeYn = isFree?"Y":"N"
    },
    async getUnitFdb() {
      await store.dispatch('getUnitFdb', this.$_payload('so', [{unitFdbNo: this.fdbNo}, {unitUseNo: this.unitUseNo}]))
          .then(res => {
            if (res.success) {
              const {fdb="" , unitCmpltDt} = res.data
              this.regDt = unitCmpltDt;

              store.commit('setUnitFeedback', {
                feedbackNo: this.fdbNo,
                feedback: fdb.replaceAll("\n", "<br/>"),
                unitId: res.data.unitId,
                sltUnitMappingUseNo : res.data.sltUnitMappingUseNo,
                unitCompletedDate: unitCmpltDt
              })
              this.unitUseNo = res.data.sltUnitMappingUseNo !== 0 ? res.data.sltUnitMappingUseNo : res.data.unitId
            } else {
              store.commit('initUnitFeedback')
            }
          })
          .catch(error => {
            store.commit('initUnitFeedback')
            console.error(error)
          })
          .finally(() => {})

    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-btn.btn-close {
  position: absolute;
  top: calc(10px + var(--system-bar-height));
  left: 10px;
  background-color: #fff;
}

::v-deep.v-btn.btn-guide {
  position: absolute;
  top: calc(15px + var(--system-bar-height));
  right: 23px;
}
</style>
